import { render, staticRenderFns } from "./BookCreateTranslation.vue?vue&type=template&id=1043cb2d&"
import script from "./BookCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./BookCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./BookCreateTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports